// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"0cb3fbb13b82caeeea87","587":"fff891ab1a68e197c94b","846":"0735dd84ccfb996827db"}[chunkId] + ".js";
};